import { render } from "./DsoStepOneRegistration.vue?vue&type=template&id=1be0d2c7&scoped=true"
import script from "./DsoStepOneRegistration.vue?vue&type=script&lang=js"
export * from "./DsoStepOneRegistration.vue?vue&type=script&lang=js"

import "./DsoStepOneRegistration.vue?vue&type=style&index=0&id=1be0d2c7&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be0d2c7"]])

export default __exports__